const formatNumber = (number) => {
  if (number || number === 0) {
    return new Intl.NumberFormat('ru-RU').format(number)
  }

  return 0
}

export { formatNumber }
